const SUPPORTED_LANGS = ['en', 'ar', 'fr', 'ru'];

export function normalizeLang(lang) {
  if (!lang || typeof lang !== 'string') return 'en';
  const base = lang.trim().toLowerCase().split('-')[0];
  return SUPPORTED_LANGS.includes(base) ? base : 'en';
}

export function cmsValue(value, lang) {
  const l = normalizeLang(lang);
  if (!value) return '';
  if (typeof value === 'string') return value;
  if (typeof value === 'object') {
    const direct = value[l];
    if (typeof direct === 'string' && direct.trim()) return direct;
    const en = value.en;
    if (typeof en === 'string' && en.trim()) return en;
  }
  return '';
}

export function cmsField(siteSettings, key, lang, fallback = '') {
  const l = normalizeLang(lang);
  const fromTranslations = siteSettings?.translations?.[l]?.[key];
  if (typeof fromTranslations === 'string' && fromTranslations.trim()) return fromTranslations;

  const fromEnTranslations = siteSettings?.translations?.en?.[key];
  if (typeof fromEnTranslations === 'string' && fromEnTranslations.trim()) return fromEnTranslations;

  const direct = siteSettings?.[key];
  const directResolved = cmsValue(direct, l);
  if (directResolved) return directResolved;

  return fallback;
}

export function cmsLinkLabel(item, lang, fallback = '') {
  const l = normalizeLang(lang);
  const translated = item?.translations?.[l]?.label;
  if (typeof translated === 'string' && translated.trim()) return translated;
  return cmsValue(item?.label, l) || fallback;
}

